import { generateJSON } from "@tiptap/html";
import { DOMSerializer } from "@tiptap/pm/model";
import StarterKit from "@tiptap/starter-kit";
import { htmlBoldToMarkdown, markdownBoldToHtml } from "./client-history-markdown";
import { htmlToMarkdown, markdownToHtml } from "./client-history-md-bridge";

/** Расширения для разбора тела раздела (без historySection). */
export const historyBodyExtensions = [
  StarterKit.configure({
    heading: false,
    codeBlock: false,
    code: false,
    blockquote: false,
    horizontalRule: false
  })
];

/**
 * Секции API → JSON документа TipTap (historySection+).
 * @param {{ idPart: number, name: string, value?: string }[]} sections
 */
export function sectionsToEditorDoc(sections) {
  const list = Array.isArray(sections) ? sections : [];
  return {
    type: "doc",
    content: list.map((section) => {
      const bodyMd = htmlBoldToMarkdown(section?.value ?? "").trim();
      const html = markdownToHtml(bodyMd || "");
      const json = generateJSON(html, historyBodyExtensions);
      const content =
        Array.isArray(json.content) && json.content.length > 0
          ? json.content
          : [{ type: "paragraph" }];

      return {
        type: "historySection",
        attrs: {
          idPart: section.idPart,
          name: section.name ?? ""
        },
        content
      };
    })
  };
}

/**
 * Документ редактора → секции для PUT (каждый раздел отдельно).
 * @param {import('@tiptap/core').Editor} editor
 * @returns {{ idPart: number, value: string }[]}
 */
export function editorToSections(editor) {
  if (!editor) return [];

  const serializer = DOMSerializer.fromSchema(editor.schema);
  const result = [];

  editor.state.doc.forEach((node) => {
    if (node.type.name !== "historySection") return;

    const fragment = serializer.serializeFragment(node.content);
    const wrap = document.createElement("div");
    wrap.appendChild(fragment);
    const md = htmlToMarkdown(wrap.innerHTML).trim();
    result.push({
      idPart: node.attrs.idPart,
      value: markdownBoldToHtml(md)
    });
  });

  return result;
}

/** Снимок значений для dirty-сравнения. */
export function sectionsSnapshot(sections) {
  const list = Array.isArray(sections) ? sections : [];
  return JSON.stringify(
    list.map((s) => ({
      idPart: s.idPart,
      value: String(s.value ?? "").trim()
    }))
  );
}
